import { useMemo } from "react";
import { classNames } from "primereact/utils";
import styles from "./DesignStudioPresetCard.module.scss";
import { IDesignStudioPreset } from "../models/designStudioPresetModel";
import { DesignStudioMock } from "./DesignStudioMock";
import { DesignStudioSwatches } from "./DesignStudioSwatches";
import { buildDesignStudioPreviewStyle } from "../utils/designStudioPreviewUtility";

interface IDesignStudioPresetCardProps {
  preset: IDesignStudioPreset;
  selected: boolean;
  onSelect: (preset: IDesignStudioPreset) => void;
}

export const DesignStudioPresetCard = ({
  preset,
  selected,
  onSelect,
}: IDesignStudioPresetCardProps) => {
  // The ring and the check badge wear the preset's own accent, not the one being previewed.
  const style = useMemo(() => buildDesignStudioPreviewStyle(preset.colors), [preset.colors]);

  return (
    <button
      type="button"
      className={classNames(styles.root, { [styles.root_selected]: selected })}
      style={style}
      aria-pressed={selected}
      aria-label={preset.name}
      data-preset={preset.key}
      onClick={() => onSelect(preset)}
    >
      <span className={styles.preview}>
        <DesignStudioMock colors={preset.colors} variant="card" />
      </span>

      <span className={styles.info}>
        <span className={styles.name}>{preset.name}</span>
        <span className={styles.info_line}>
          <DesignStudioSwatches colors={preset.colors} compact />
        </span>
      </span>

      <span className={styles.check} aria-hidden>
        <svg viewBox="0 0 12 12">
          <path
            d="M2.5 6.4 5 8.8 9.6 3.6"
            fill="none"
            stroke="currentColor"
            strokeWidth="1.9"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </span>
    </button>
  );
};
